import { Component, OnInit } from "@angular/core";
import { SeoService } from "src/app/core";

@Component({
    selector: "app-splash",
    templateUrl: "./splash.component.html",
    styleUrls: ["./splash.component.scss"],
    standalone: false
})
export class SplashComponent implements OnInit {
  constructor(private seoService: SeoService) {}

  ngOnInit() {
    this.seoService.postFixTitle("Home");
  }
}
